<template>
    <section class="index-section-layout"
             :class="[
            {
            'index-section-layout--large': large,
            'index-section-layout--imaged': bgWithImage,
            'index-section-layout--call-to-action': isCallToAction
            },
            bgThemeClass
        ]"
             style=""
    >
        <StepCounterList
            v-if="3"
            class="section-layout__steps"
            :steps="3"
            :current-step="step"
        />
        <h2 v-if="title.length" class="index-section-layout__title"
            :class="titleBottomMarginClass"
        >{{ title }}</h2>
        <slot/>
    </section>
</template>

<script>
import StepCounterList from "@/components/shared/steps-counters/StepCounterList.vue";

const BG_THEMES = ['transparent', 'primary-invert', 'primary'];
const TITLE_BOTTOM_MARGIN_SIZED = ['normal', 'big'];

export default {
    name: 'section-layout',
    components: {StepCounterList},
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        bgTheme: {
            type: String,
            required: false,
            default: 'transparent',
            validator: function (theme) {
                return theme ? BG_THEMES.includes(theme) : true
            }
        },
        bgWithImage: {
            type: Boolean,
            required: false,
            default: false
        },
        large: {
            type: Boolean,
            required: false,
            default: false
        },
        titleBottomMarginSize: {
            type: String,
            required: false,
            default: 'normal',
            validator: function (size) {
                return size ? TITLE_BOTTOM_MARGIN_SIZED.includes(size) : true
            }
        },
        isCallToAction: {
            type: Boolean,
            required: false,
            default: false
        },
        step: {
            type: Number,
            required: false,
            default: 1
        }
    },
    computed: {
        bgThemeClass() {
            return `index-section-layout--bg-${this.bgTheme}`;
        },
        titleBottomMarginClass() {
            return `index-section-layout__title--margin-${this.titleBottomMarginSize}`
        }
    },
}
</script>

<style lang="scss" scoped>
.index-section-layout {
    position: relative;

    border-radius: 24px;

    $border-radius-desktop: $border-radius-medium;

    padding: rem($gap-large);

    border-radius: rem($border-radius-desktop);

    @media #{$screen-big} {
        padding: rem($gap-big);
    }

    @media (#{$screen-small}) {
        padding: rem($gap-medium) rem($gap-normal);
    }

    &--large {
        $gap-large: 68px;
        $gap-big: 60px;
        $vertical-padding-tablet: 40px;

        padding: rem($gap-large) 0;

        @media #{$screen-big} {
            padding: rem($gap-big) 0;
        }

        @media #{$screen-medium} {
            padding: rem(24px) 0 $vertical-padding-tablet;
        }

        @media #{$screen-small} {
            padding-bottom: rem(45px);
        }
    }

    &--bg-transparent {
        background-color: transparent;
    }

    &--bg-primary {
        background-color: $primary;
    }

    &--bg-primary#{&}--imaged {
        background: linear-gradient(0deg, rgba($primary, 0.9) 0%, rgba($primary, 0.90) 100%), url('@/assets/images/hands-with-pen.png'), $alto 50%;
        background-repeat: no-repeat;
        background-size: cover;
    }

    &--bg-primary-invert {
        background-color: $primary-invert;
    }

    &--imaged {
        background-size: cover;
        background-repeat: no-repeat;
    }

    &--call-to-action {
        @media #{$screen-medium} {
            padding: rem($gap-medium);
        }
    }

    &__title {
        $bottom-margin-normal-desktop: $gap-big;
        $bottom-margin-big-desktop: 40px;

        @include text-xxl;

        @media #{$screen-big} {
            font-size: rem($font-size-huge);
        }

        @media #{$screen-small} {
            font-size: rem($font-size-large);
        }

        &--margin-normal {
            // 32
            margin-bottom: rem($bottom-margin-normal-desktop);

            @media #{$screen-small} {
                margin-bottom: rem($gap-medium);
            }
        }

        &--margin-big {
            // 40
            margin-bottom: rem($bottom-margin-big-desktop);

            // 32
            @media #{$screen-big} {
                margin-bottom: rem($bottom-margin-normal-desktop);
            }

            // 24
            @media #{$screen-small} {
                margin-bottom: rem($gap-medium);
            }
        }
    }
}

.section-layout__steps {
    position: absolute;
    top: rem(48);
    right: rem(48);

    @media #{$screen-big} {
        top: rem(32);
        right: rem(32);
    }

    @media #{$screen-small} {
        position: static;
        top: rem(24);
        left: rem(12);
    }

    &:not(:last-child) {
        margin: 0;

        @media #{$screen-small} {
            margin-bottom: rem(24);
        }
    }
}
</style>